$('.click--down').click(function(){
    if ($(this).hasClass('down')) {
        $(this).parent().find(".accordion--slide").slideDown();
        $(this).addClass("up").removeClass("down");
    } else {
        $(this).parent().find(".accordion--slide").slideUp();
            $(this).addClass("down").removeClass("up");
    }
})




if ($(window).width() < 768) {
    kontaktAccordion();
}


// $(window).on('resize', function() {
//     if ($(window).width() < 768) {
//         kontaktAccordion();
//     }
// });



function kontaktAccordion() {

    $('.standort--inner--wrap .standort--location').click(function(){

        $(this).css("pointer-events", 'none');
        if ($(this).hasClass('down')) {
            $('.standort--inner--wrap .standort--location').not(this).addClass("down").removeClass("up");
            $('.hidden--address').slideUp();
            $(this).parent().find(".hidden--address").slideDown();
            $(this).addClass("up").removeClass("down");

        } else {
            $(this).parent().find(".hidden--address").slideUp();
            $(this).addClass("down").removeClass("up");
        }

        setTimeout(function() {
            $('.standort--inner--wrap .standort--location').css("pointer-events", 'all');
        }, 500); // .5 second delay


    })

}
